import React, { useState } from 'react';
import CheckoutHeader from '../../../components/checkout/CheckoutHeader';
import Box from '@mui/system/Box';
import styles from './style.module.css';
import {
    Button,
    Grid,
    Modal,
    Typography,
} from "@mui/material";
import LeftSidebar from '../../../components/sidebars/LeftSidebar';
import { UserCommonStyles } from "../../../styles/CommonStyles";
import { useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { RoutingLinks, Type } from '../../../utils/constants';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClipLoader from "react-spinners/ClipLoader";
import SocialIconSection from '../../../components/sidebars/SocialIconSection';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import StripePaymentMethod from './StripePaymentMethod';

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#fff",
    boxShadow: 24,
    pb: 1,
    pt: 4,
    px: 4
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "");

const CheckoutPayment = () => {

    const commonStyle = UserCommonStyles();
    const history = useHistory();
    const { t: translation } = useTranslation();

    const [checkoutData, setCheckoutData] = useState<any>(JSON.parse(localStorage.getItem(Type?.shoppingCartCheckout) || '{}'));
    const [open, setOpen] = useState<boolean>(false);

    return (
        <Box >
            <Box className={styles.windowColor}>
                <Grid container>
                    <Grid item md={3}>
                        <LeftSidebar />
                        {/* <SocialIconSection /> */}
                    </Grid>

                    <Grid item md={9} >
                        <Typography mt={5} ml={2} mb={3}
                            className={styles.heading}
                        >
                            Payment
                        </Typography>
                        <Box className={styles.subContainer}>
                            <CheckoutHeader
                                step2={true}
                                step3={true}
                            />
                            <Elements stripe={stripePromise}>
                                <StripePaymentMethod
                                    checkoutData={checkoutData}
                                    shippingAddress={checkoutData?.shipping_address}
                                    setOpen={setOpen}
                                />
                            </Elements>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box className={commonStyle.textCenter}>
                        <div className={styles.wrapper}>
                            <svg className={styles.checkmark} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                <circle className={styles.checkmark__circle} cx="26" cy="26" r="25" fill="none" />
                                <path className={styles.checkmark__check} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                            </svg>
                        </div>
                        {/* <CheckCircleIcon
                            style={{ color: '#22c3a9', fontSize: 80 }}
                        /> */}
                    </Box>
                    <Box className={commonStyle.py15} mt={-3}>
                        <Box className={commonStyle.textCenter}>
                            <Typography pb={1}>Congratulation! Your order has been placed.</Typography>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <Box className={` ${commonStyle.blueBtn} ${commonStyle.py15}`}>
                                <Button
                                    fullWidth
                                    onClick={() => {
                                        history.push(RoutingLinks.marketplace);
                                        setOpen(false);
                                    }}
                                >Ok
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};

export default CheckoutPayment; 